import toast from 'react-hot-toast';
import i18n from '../i18n';

// Track which milestones have been celebrated so each one fires only once
// across the lifetime of the account on this device.
const SHOWN_KEY = 'tg_daruma_milestones_shown';

function getShown(): Set<string> {
  try {
    return new Set(JSON.parse(localStorage.getItem(SHOWN_KEY) || '[]'));
  } catch {
    return new Set();
  }
}

function markShown(id: string): void {
  const shown = getShown();
  shown.add(id);
  try {
    localStorage.setItem(SHOWN_KEY, JSON.stringify([...shown]));
  } catch {
    /* ignore */
  }
}

export type MilestoneType = 'trip' | 'stamp' | 'streak' | 'location' | 'share';

interface MilestoneDef {
  id: string;
  check: (type: MilestoneType, value: number) => boolean;
  messageKey: string;
}

const MILESTONES: MilestoneDef[] = [
  { id: 'first-trip',    check: (t, v) => t === 'trip' && v === 1,     messageKey: 'daruma.milestoneFirstTrip' },
  { id: 'first-stamp',   check: (t, v) => t === 'stamp' && v === 1,    messageKey: 'daruma.milestoneFirstStamp' },
  { id: 'streak-7',      check: (t, v) => t === 'streak' && v === 7,   messageKey: 'daruma.milestoneStreak7' },
  { id: 'streak-30',     check: (t, v) => t === 'streak' && v === 30,  messageKey: 'daruma.milestoneStreak30' },
  { id: 'locations-10',  check: (t, v) => t === 'location' && v === 10, messageKey: 'daruma.milestoneLocations10' },
  { id: 'locations-50',  check: (t, v) => t === 'location' && v === 50, messageKey: 'daruma.milestoneLocations50' },
  { id: 'first-share',   check: (t, v) => t === 'share' && v === 1,    messageKey: 'daruma.milestoneFirstShare' },
];

export function checkMilestone(type: MilestoneType, value: number): void {
  const shown = getShown();
  for (const m of MILESTONES) {
    if (shown.has(m.id)) continue;
    if (m.check(type, value)) {
      markShown(m.id);
      // Fire the celebration toast a beat after the action's own toast so
      // they don't visually collide in the speech-bubble queue.
      setTimeout(() => {
        toast.success(i18n.t(`pages:${m.messageKey}`), { duration: 6000 });
      }, 2000);
      return;
    }
  }
}
